// extracted by mini-css-extract-plugin
export default {"text":"page-heading_text__An-OW"};